<template>
  <Head title="Report Builder - List" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0"> 
          <report-builder-list 
            :report_pages="report_pages" 
            :clients="clients"
          ></report-builder-list>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';

defineProps({
  report_pages: Array,
  clients: Array
});
</script>

